export const listWhatsaapTemplates = /* GraphQL */ `
  query ListWhatsaapTemplates(
    $filter: ModelWhatsaapTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWhatsaapTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        createdAt
        updatedAt
        variablesCount
        mapping {
          variable
          key
        }
        type
        channel
      }
      nextToken
    }
  }
`;

export const getWhatsaapTemplatesByOrganization = /* GraphQL */ `
  query GetWhatsaapTemplatesByOrganization(
    $organizationId: ID!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWhatsaapTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getWhatsaapTemplatesByOrganization(
      organizationId: $organizationId
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        content
        variablesCount
        organizationId
        createdAt
        updatedAt
        mapping {
          variable
          key
        }
        channel
        type
      }
      nextToken
    }
  }
`;

export const getWhatsaapTemplate = /* GraphQL */ `
  query GetWhatsaapTemplate($id: ID!) {
    getWhatsaapTemplate(id: $id) {
      id
      content
      createdAt
      updatedAt
      variablesCount
    }
  }
`;
